/* eslint-disable no-prototype-builtins */
/* eslint-disable no-console */

import { LogType } from './_types';
import { CONTRACT_DISPLAY_ERRORS, ERROR_MSGS, EVestaErrorType, VestaError } from './errors';

function getRawMsg<T extends ERROR_MSGS | string>(error: any): T {
  if ('data' in error) {
    if ('message' in error.data) {
      return error.data.message as T;
    }
  }

  if ('message' in error) {
    if (error.message in CONTRACT_DISPLAY_ERRORS) {
      return error.message as T;
    }
  }

  if (error.code in CONTRACT_DISPLAY_ERRORS) {
    return error.code as T;
  }

  return ERROR_MSGS.INVALID_ERROR as T;
}

export function logMe(msg: any, type: LogType = 'log') {
  if (
    !process.env.NODE_ENV ||
    process.env.NODE_ENV === 'development' ||
    getRawMsg<ERROR_MSGS>(msg) === ERROR_MSGS.INVALID_ERROR
  ) {
    console[type](msg);
  }
}

export function lookupDisplayError(err: string | Error): string {
  const raw = getRawMsg<ERROR_MSGS>(err);

  if (!err) {
    return CONTRACT_DISPLAY_ERRORS[ERROR_MSGS.INVALID_ERROR];
  } else if (raw in CONTRACT_DISPLAY_ERRORS) return CONTRACT_DISPLAY_ERRORS[raw];
  return raw as string;
}

/**
 * Used to create an appropriate error to throw made from arbitrary responses. Will also log the raw error.
 * @param error string or Error instance.
 * @param eType Type of the error to throw.
 */
export function makeThrowable(
  error: any,
  eType: EVestaErrorType = EVestaErrorType.INTERNAL,
  extra = '',
): VestaError {
  logMe(error, 'error');

  if (error instanceof VestaError) return error;
  else return new VestaError(lookupDisplayError(error as any), eType, extra);
}
